export default {
  fontWeight: 'var(--has-no-font-weight)',
  fontWeightMobile: 'var(--has-no-font-weight)',
  bulletColor: 'var(--black)',
  tableDisplay: 'table',
  letterSpacing: 'var(--has-no-letter-spacing)',
  tableRowColorOne: '#eee',
  tableRowColorTwo: '#e2e2e2',
  tableRowWeight: 'bold',
  tablePadding: '5px',
  mobileFontSize: '1.8rem',
  fontSize: '1.5rem',
  textColor: 'var(--base-brown)',
  borderRadius: '1.75rem',
  borderWidth: '2px',
  borderColor: 'var(--black)',
  margin: '1rem auto',
  ctaTextColor: 'var(--dark-teal)',
  ctaButtonPadding: '.8em 5em',
  buttonBackgroundColor: 'var(--transparent)',
};
